function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "41",
  height: "41",
  viewBox: "0 0 41 41"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "hccurj8iza"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.330000 0 0 0 0 0.330000 0 0 0 0 0.330000 0 0 0 1.000000 0"
}))), /*#__PURE__*/React.createElement("g", {
  filter: "url(#hccurj8iza)",
  transform: "translate(.5 .5)",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20 8c-5.523 0-10 4.477-10 10 0 1.445.628 3.108 1.772 4.965.8 1.3 1.839 2.667 3.058 4.072a54.664 54.664 0 003.248 3.417l.56.534.718.664.205.183c.251.22.627.22.878 0l.412-.371.512-.476c.179-.168.365-.347.56-.534a54.944 54.944 0 003.247-3.417c1.22-1.405 2.257-2.773 3.058-4.072C29.372 21.108 30 19.445 30 18c0-5.523-4.477-10-10-10zm0 1.333A8.667 8.667 0 0128.667 18c0 1.15-.548 2.6-1.574 4.265-.759 1.232-1.755 2.543-2.93 3.898a53.925 53.925 0 01-3.168 3.333l-.546.521-.449.418-.449-.418a53.925 53.925 0 01-3.714-3.854c-1.175-1.355-2.171-2.666-2.93-3.898C11.881 20.6 11.333 19.15 11.333 18A8.667 8.667 0 0120 9.333z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 13.72a.5.5 0 01.992-.09l.008.09v8.78a.5.5 0 01-.992.09L17 22.5v-8.78z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.918 14.188l-.062-.065-1.994-1.543a.505.505 0 00-.664 0l-1.994 1.543-.062.065a.5.5 0 00.72.689l1.668-1.291 1.668 1.29a.5.5 0 00.72-.687z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M22 22.28a.5.5 0 00.992.09l.008-.09V13.5a.5.5 0 00-.992-.09L22 13.5v8.78z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.918 21.812l-.062.065-1.994 1.543a.505.505 0 01-.664 0l-1.994-1.543-.062-.065a.5.5 0 01.72-.689l1.668 1.291 1.668-1.29a.5.5 0 01.72.687z"
})))))));